import React, {Component} from 'react';
import './GeneralCheckCategoryCard.css';
import ProgressBar from "../pages/scanner/progressBar/ProgressBar";
import Label from "../label/Label";
import PrimaryButton from "../primaryButton/PrimaryButton";

export default class GeneralCheckCategoryCard extends Component{
  render(){
    return(
    <div className="g-general-check-category-card">
			<ProgressBar progress={this.props.category.completed} total={this.props.category.total}/>
			<div className={'flex-row'}>
			<Label dark bold>{this.props.category.name}</Label>
			<PrimaryButton onClick={() => {
				this.props.onContinue(this.props.category.id);
			}}>Continue</PrimaryButton>
			</div>
		</div>
    )
  }
}